import styled from 'styled-components';
import { media } from '../../../common/styles/styleUtil';
import { DeviceType } from '../../../store/common/type';

interface InfoAndShareWrapperProps {
  deviceType: DeviceType;
}
export const TitleWrapper = styled.div`
  width: 100%;
  ${media.xs`
    padding: 24px 0 0 0;
  `}
  h1 {
    margin-bottom: 24px;
    font-size: 32px;
    color: #333f48;
    font-weight: 400;
    line-height: 38px;
    word-break: break-word;
    ${media.xs`
      font-size: 24px;
      line-height: 28px;
      font-weight: 500;
      margin-left: 16px;
      margin-right: 16px;
      margin-bottom: 16px;
    `};
  }
`;

export const InfoAndShareWrapper = styled.div<InfoAndShareWrapperProps>`
  display: flex;
  flex-direction: ${(props) =>
    props.deviceType === 'mobile' ? 'column' : 'row'};
  justify-content: space-between;
`;

export const Info = styled.div`
  margin-bottom: 12px;
  font-size: 14px;
  ${media.xs`
    margin-left: 16px;
    margin-right: 16px;
  `}
  padding-top: 4px;
  font-weight: 300;
  a {
    font-weight: 400;
  }
`;
